import { useMemo } from 'react';
import { isDateInRange } from '../utils/adminUtils';

export const useFilteredReports = (reports, searchTerm, filterStatus, filterRole, filterDateRange) => {
  return useMemo(() => {
    return reports.filter(report => {
      const reportedUserName = report.reported_user?.full_name || '';
      const reportedJobTitle = report.reported_job?.title || '';
      
      const matchesSearch = reportedUserName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           reportedJobTitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           (report.reason || '').toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesStatusFilter = filterStatus === 'all' || report.status === filterStatus;
      const matchesPriorityFilter = filterRole === 'all' || report.priority === filterRole;
      const matchesDateFilter = isDateInRange(report.created_at, filterDateRange);
      
      return matchesSearch && matchesStatusFilter && matchesPriorityFilter && matchesDateFilter;
    });
  }, [reports, searchTerm, filterStatus, filterRole, filterDateRange]);
};

export const useFilteredUsers = (users, searchTerm, filterStatus, filterRole, filterDateRange, currentUserRole) => {
  return useMemo(() => {
    return users.filter(user => {
      // Moderators cannot see admin users
      if (currentUserRole === 'moderator' && user.role === 'admin') {
        return false;
      }

      const matchesSearch = (user.full_name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                           (user.email || '').toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesStatusFilter = filterStatus === 'all'
        || (filterStatus === 'pending_verification' ? user.identity_verification_status === 'pending' : user.moderation_status?.status === filterStatus);
      const matchesRoleFilter = filterRole === 'all' || user.role === filterRole;
      const matchesDateFilter = isDateInRange(user.created_at, filterDateRange);
      
      return matchesSearch && matchesStatusFilter && matchesRoleFilter && matchesDateFilter;
    });
  }, [users, searchTerm, filterStatus, filterRole, filterDateRange, currentUserRole]);
};

export const useFilteredJobs = (jobs, searchTerm, filterStatus, filterRole, filterDateRange) => {
  return useMemo(() => {
    return jobs.filter(job => {
      const matchesSearch = (job.title || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                           (job.company || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                           (job.description || '').toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesStatusFilter = filterStatus === 'all' || job.status === filterStatus;
      const matchesTypeFilter = filterRole === 'all' || job.job_type === filterRole;
      const matchesDateFilter = isDateInRange(job.created_at, filterDateRange);
      
      return matchesSearch && matchesStatusFilter && matchesTypeFilter && matchesDateFilter;
    });
  }, [jobs, searchTerm, filterStatus, filterRole, filterDateRange]);
};
